const generalFunctionalities = {
  DocumentEmbedding: {
    title: "Upload Files",
    description: "Store books, articles, excel files, and other documents",
  },
  // DynamicExcel: {
  //   title: "Store Excel Data:",
  //   description: "Access your Excel files from anywhere, anytime",
  // },
  ConnectDatabase: {
    title: "Database",
  description: "Bring your database to Smart Manager",
  },
};

export const industries: { [key: string]: any } = {
  Medicine: {
    industrySpecificIndexAccess: {
      "search-patient-records": "A detailed summary of a patient's medical records, including demographics, medical history, medications, allergies, lab results, and immunizations",
    },
    functions: [
      {
        name: "get_patient_records",
        description: "A detailed summary of a patient's medical records, including demographics, medical history, medications, allergies, lab results, and immunizations",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      personalDemographics: "Basic personal information including name, DOB, gender, and marital status.",
      insuranceDetails: "Details on insurance provider, policy number, and coverage.",
      healthcareProviders: "Information on healthcare providers, including primary and specialist doctors.",
      medicalHistory: "Record of past and current medical diagnoses, surgeries, family history, and social habits.",
      assessmentPlan: "Provider’s assessments, differential diagnoses, and treatment plans.",
      immunizationRecords: "Record of vaccines received by the individual.",
      treatmentPlans: "Details on current and past treatment plans and their progress.",
      consentsAuthorizations: "Legal forms for treatment consent and authorization and documents like living wills and do-not-resuscitate orders.",
      billingPayment: "Details on services rendered, payments, and outstanding balances.",
      laboratoryImagingResults: "Records of lab tests, imaging studies, and pathology reports.",
      physicalExaminationRecords: "Physical metrics like weight, height, and other examinations.",
      legalDocuments: "Legal forms like procedure consent and workers’ compensation claims.",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Medical Records",
        description: "Fill up patient records from images",
      },
      ImageTo3D: {
        isComingSoon: true,
        title: "X-ray to 3D",
        description: "Turn X-ray files into interactive 3D images",
      },
    },
  },
  Education: {
    industrySpecificIndexAccess: {
      "search-students-records": "A detailed summary of students' records, including demographics",
    },
    functions: [
      {
        name: "get_student_records",
        description: "A detailed summary of a patient's medical records, including demographics, medical history, medications, allergies, lab results, and immunizations",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Student Records",
        description: "Picture to Text. Pre-fill student records based on images.",
      },
    },
  },
  Finance: {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  Construction: {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  "Real Estate": {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,

      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  Retail: {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,

      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  Hospitality: {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  "Legal Services": {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  Logistics: {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  Telecom: {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  "Art and Music": {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  Environmental: {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  Entertainment: {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  Marketing: {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
  Other: {
    industrySpecificIndexAccess: {
      index: "description",
    },
    functions: [
      {
        name: "",
        description: "",
        parameters: {
          type: "object",
          properties: {
            query: {
              type: "string",
              description: "The query to search for, e.g. 'joe smith'",
            },
          },
          required: ["query"],
        },
      },
    ],
    categories: {
      name: "Name",
    },
    functionalities: {
      ...generalFunctionalities,
      ImageToText: {
        title: "Client Records",
        description: "Picture to Text. Pre-fill client records based on images.",
      },
    },
  },
};
